import {HashData} from '@/modules/files/files_module';
import {Selectors} from '@/store/selectors/selectors';

export class FileSyncManager {
    constructor(private selectors: Selectors) {}

    public filterFilesToUploadBasedOnHashes = async (args: {
        directoryPath: string;
        hashDatas: HashData[];
        workspaceId: string;
        projectId: string;
    }) => {
        const fileInfos = await this.selectors.getFilesForProject({project_id: args.projectId}, {workspace_id: args.workspaceId});

        const filePaths: string[] = [];
        for (const hashData of args.hashDatas) {
            const relativePath = hashData.relativePath;
            const matchingFileInfo = fileInfos.find(fileInfo => fileInfo.relative_path === relativePath);
            if (matchingFileInfo) {
                if (matchingFileInfo.hash !== hashData.hash) {
                    filePaths.push(relativePath);
                }
            } else {
                filePaths.push(relativePath);
            }
        }
        return filePaths;
    }
}
